<!-- //
数据源映射配置
@auth xuyd
@date 2024-09-15
//-->
<template>
  <div class="form" ref="refDataMapping">
    <div class="mb10 mt10">
      <div class="flex-row flex-valign-center">
        <span v-if="dragSortable" class="move"></span>
        <span class="label" :style="{width: width, 'text-align': 'right'}">视图显示名</span>
        <span class="equal"></span>
        <span class="label" :style="{width: width}">返回字段名</span>
        <span></span>
      </div>
    </div>
    <div id="dataMappingBody">
      <div v-for="(mapping, index) in dataMapping" :key="index" class="flex-row flex-valign-center">
        <span v-if="dragSortable" class="dragSortableHandle iconfont iconfont-list move" style="text-align: center"></span>
        <el-input v-model="mapping.label" size="mini" class="right" :style="{width: width}" @change="handleChange"/>
        <span class="equal">=</span>
<!--        <el-input v-model="mapping.prop" size="mini" :style="{width: width}" @change="handleChange"/>-->
        <SelectorKeyValue v-model="mapping.field"
                          :clearable="true"
                          size="mini"
                          :style="{width: width}"
                          popper-class="dv-select-pop"
                          :datasource-list="dataPropList"
                          @change="handleChange"
        />
        <div style="width: 25px; text-align: center;">
          <el-button type="text" size="mini" @click="handleDelete(index)">
            <el-icon class="el-icon-remove-outline"/>
          </el-button>
        </div>
      </div>
    </div>
    <div>
      <el-button type="text" icon="el-icon-circle-plus" @click="handleAdd">新增映射</el-button>
    </div>
  </div>
</template>

<script>

import Sortable from "sortablejs";

export default {
  name: 'CompSelectDataMapping',
  data() {
    return {
      arrayFlag: false,
      dataMapping: [],
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    dragSortable: {// 是否可以拖动排序
      type: Boolean,
      default: false
    },
    value: [Array, Object],
    dataPropList: {// 接口数据的的属性下拉
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    width() {
      return 'calc((100% - 75px) / 2)';
    }
  },
  watch: {
    value: {
      handler: function (val) {
        this.arrayFlag = Array.isArray(val);
        if (this.arrayFlag) {// [{prop, label}]
          this.dataMapping = val;
        } else {
          this.dataMapping = this.form2Array(val);
        }
      },
      immediate: true
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.dragSortable) {
        this.initSortable();
      }
    });
  },
  methods: {
    initSortable() {
      const elTbody = document.getElementById('dataMappingBody');
      Sortable.create(elTbody, {
        animation: 150, // 动画
        // sort: true,
        handle: '.dragSortableHandle',
        onEnd: (evt) => {
          // console.log("initSortable start=====>", evt, JSON.stringify(this.dataMapping));
          let [beforeBody, oldIndex, afterBody, newIndex, item] = [evt.from, evt.oldIndex, evt.to, evt.newIndex, evt.item];
          /*将sortable移动过去的DOM复位*/
          //删掉已移过去的dom
          afterBody.removeChild(item);
          //添加已移除的dom
          beforeBody.insertBefore(item, beforeBody.children[oldIndex]);

          const curRow = this.dataMapping.splice(evt.oldIndex, 1)[0];
          this.dataMapping.splice(evt.newIndex, 0, curRow);
          this.handleChange();
        },
      });
    },

    /**
     * 正对表格类型的映射转成form表单
     * @param arr [{prop, label}]
     */
    array2Form(arr) {
      let mapping = {};
      arr = arr || [];
      arr.forEach(item => {
        mapping[item.label] = item.prop;
      });
      return mapping;
    },

    /**
     * 配置的对象dataMapping中key是view使用的内置变量（固定）
     * @param mapping
     * @returns {*[]}
     */
    form2Array(mapping) {
      let arr = [];
      mapping = mapping || {};
      Object.keys(mapping).forEach(key => {
        arr.push({prop: mapping[key], label: key});
      });
      return arr;
    },

    /**
     * 初始化
     */
    initData() {
      return {label: '', prop: null};
    },

    /**
     * 新增
     */
    handleAdd() {
      this.dataMapping = this.dataMapping || [];
      let index = this.dataMapping.length - 1;
      this.dataMapping.splice(index + 1, 0, this.initData());
      this.handleChange();
    },

    /**
     * 删除
     * @param index
     */
    handleDelete(index) {
      this.dataMapping.splice(index, 1);
      if (this.dataMapping.length <= 0) {
        this.dataMapping = [this.initData()];
      }
      this.handleChange();
    },

    /**
     * change事件
     */
    handleChange() {
      if (this.arrayFlag) {
        this.$emit('change', this.dataMapping);
      } else {
        this.$emit('change', this.array2Form(this.dataMapping));
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/variables.less';

.form {
  height: auto;

  .label {
    font-size: 12px;
    color: @label-color;
  }

  .move {
    width: 30px;
    cursor: move;
    color: @label-color;
  }

  .equal {
    width: 20px;
    padding: 0 5px;
    color: @label-color;
  }

  .center {
    :deep(.el-input__inner) {
      text-align: center;
    }
  }

  .right {
    :deep(.el-input__inner) {
      text-align: right;
    }
  }
}
</style>

